import type { Language } from './language-store';

function normalizeKey(text: string): string {
  return text
    .trim()
    .toLowerCase()
    .replace(/ß/g, 'ss')
    .replace(/[–—]/g, '-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');
}

const EN_TRANSLATIONS: Record<string, string> = {
  'dashboard': 'Dashboard',
  'beschaffungsagent': 'Procurement Agent',
  'ubersicht': 'Overview',
  'system': 'System',
  'auftragsbestatigungen': 'Order Confirmations',
  'fehlende ab': 'Missing OC',
  'eskalationen': 'Escalations',
  'messberichte': 'Inspection Reports',
  'lieferanten': 'Suppliers',
  'lieferungen': 'Deliveries',
  'unklarheiten': 'Unclear Items',
  'aktivitat': 'Activity',
  'steuerung': 'Control',
  'reporting': 'Reporting',
  'benutzer': 'Users',
  'benutzerverwaltung': 'User Management',
  'admin': 'Admin',
  'einkauf': 'Procurement',
  'qualitat': 'Quality',
  'logistik': 'Logistics',
  'abmelden': 'Log out',
  'aktiv': 'Active',
  'inaktiv': 'Inactive',
  'gestoppt': 'Stopped',
  'agent aktiv': 'Agent active',
  'agent gestoppt': 'Agent stopped',
  'daten aktualisieren': 'Refresh data',
  'theme wechseln': 'Toggle theme',
  'nicht verfugbar': 'Not available',
  'suche': 'Search',
  'lade daten...': 'Loading data...',
  'lade seite...': 'Loading page...',
  'keine daten vorhanden': 'No data available',
  'keine log-eintrage vorhanden.': 'No log entries available.',
  'eintrage': 'entries',
  'eintrag': 'entry',
  'von': 'of',
  'seite': 'Page',
  'erneut versuchen': 'Try again',
  'seite neu laden': 'Reload page',
  'wiederherstellung aktiv': 'Recovery active',
  'technischer hinweis': 'Technical note',
  'anwendung musste in den global-fallback wechseln': 'Application switched to global fallback',
  'ein fehler ist vor dem normalen layout aufgetreten. der beschaffungsagenten-client bleibt deshalb in einem globalen sicherheits-fallback und kann von hier aus neu initialisiert werden.': 'An error occurred before the normal layout loaded. The client remains in a global safe fallback and can be re-initialized from here.',
  'dashboard konnte nicht vollstandig geladen werden': 'Dashboard could not be fully loaded',
  'mindestens ein bereich des beschaffungsagenten hat beim rendern oder laden der daten einen fehler ausgelost. die oberflache bleibt in einem sicheren fallback statt in einem weissen screen.': 'At least one section failed while rendering or loading data. The UI remains in a safe fallback instead of a blank screen.',
  'reporting ist vorubergehend nicht verfugbar': 'Reporting is temporarily unavailable',
  'der reporting-bereich konnte eine oder mehrere datenquellen nicht verarbeiten und wurde in einen segmentierten fehler-fallback umgeleitet.': 'The reporting area could not process one or more data sources and switched to a segmented error fallback.',
  'bestellubersicht oder eskalationen konnten nicht geladen werden': 'Order overview or escalations could not be loaded',
  'die datenintensiven tabellen und diagramme dieser ansicht sind in einen lokalen fehler-fallback gewechselt. andere bereiche der anwendung bleiben davon unberuhrt.': 'The data-heavy tables and charts in this view switched to a local error fallback. Other areas remain unaffected.',
  'agent-kontrolle': 'Agent controls',
  'letzter lauf': 'Last run',
  'letztes zyklusergebnis': 'Latest cycle result',
  'neue e-mails': 'New emails',
  'verarbeitete abs': 'Processed OCs',
  'fehler': 'Errors',
  'konfiguration': 'Configuration',
  'abgleich-toleranzen': 'Matching tolerances',
  'letzte log-eintrage': 'Latest log entries',
  'sprache': 'Language',
  'deutsch': 'German',
  'englisch': 'English',
  'sprache wurde auf deutsch gesetzt.': 'Language set to German.',
  'sprache wurde auf englisch gesetzt.': 'Language set to English.',
  'starten': 'Start',
  'stoppen': 'Stop',
  'manueller zyklus': 'Manual cycle',
  'neustart': 'Restart',
  'agent gestartet': 'Agent started',
  'zyklus lauft bereits – bitte warten': 'Cycle already running - please wait',
  'zyklus abgeschlossen': 'Cycle completed',
  'agent neu gestartet': 'Agent restarted',
  'fehler beim starten des agents': 'Failed to start agent',
  'fehler beim stoppen des agents': 'Failed to stop agent',
  'fehler beim manuellen zyklus': 'Manual cycle failed',
  'fehler beim neustart': 'Restart failed',
  'anmelden...': 'Signing in...',
  'anmelden': 'Sign in',
  'mit microsoft anmelden': 'Sign in with Microsoft',
  'microsoft-login nicht konfiguriert': 'Microsoft login not configured',
  'oder': 'or',
  'benutzername': 'Username',
  'passwort': 'Password',
  'benutzername oder passwort falsch': 'Incorrect username or password',
  'verbindungsfehler. ist die api erreichbar?': 'Connection error. Is the API reachable?',
  'microsoft-login ist nicht konfiguriert. bitte admin kontaktieren.': 'Microsoft login is not configured. Please contact an admin.',
  'kein token von microsoft erhalten': 'No token received from Microsoft',
  'kein zugriff. bitte admin kontaktieren fur rollenzuweisung.': 'No access. Please contact an admin for role assignment.',
  'microsoft-anmeldung fehlgeschlagen': 'Microsoft sign-in failed',
  'excel export': 'Excel export',
  'keine aktivitaten gefunden.': 'No activities found.',
  'aktivitaten': 'activities',
  '0 eintrage': '0 entries',
  'nicht zugeordnet': 'Unassigned',
  'heute eingegangen': 'Received today',
  'was sind unklarheiten?': 'What are unclear items?',
  'e-mails, die keiner bestehenden erp-bestellung zugeordnet werden konnten. mogliche grunde: fehlende bestellnummer, unbekannter lieferant oder ungewohnliches e-mail-format. diese e-mails erfordern manuelle prufung.': 'Emails that could not be matched to an ERP order. Possible reasons: missing order number, unknown supplier, or unusual email format. These emails require manual review.',
  'absender': 'Sender',
  'betreff': 'Subject',
  'empfangen': 'Received',
  'keine unklarheiten gefunden': 'No unclear items found',
  'keine ungeklarten e-mails vorhanden.': 'No unresolved emails available.',
  'gesamt': 'Total',
  'vollstandig': 'Complete',
  'unvollstandig': 'Incomplete',
  'eingegangen': 'Received',
  'weitergeleitet an': 'Forwarded to',
  'nicht erkannt': 'Not recognized',
  'eingang der letzten 14 tage': 'Incoming in the last 14 days',
  'vollstandigkeit': 'Completeness',
  'keine messberichte gefunden': 'No inspection reports found',
  'noch keine messberichte empfangen – messberichte werden automatisch erkannt, wenn eine e-mail mit entsprechenden schlagwortern eingeht.': 'No inspection reports received yet - reports are detected automatically when an email contains matching keywords.',
  'lieferanten gesamt': 'Suppliers total',
  'performance score': 'Performance score',
  'gut': 'Good',
  'akzeptabel': 'Acceptable',
  'kritisch': 'Critical',
  'termintreue': 'On-time delivery',
  'dokumentenqualitat': 'Document quality',
  'reaktionszeit': 'Response time',
  'letzte abfrage': 'Last request',
  'lieferant': 'Supplier',
  'score': 'Score',
  'status': 'Status',
  'keine lieferanten gefunden': 'No suppliers found',
  'noch keine lieferantendaten vorhanden. erst wenn abs verarbeitet wurden, erscheinen hier scores.': 'No supplier data yet. Scores appear after order confirmations are processed.',
  'gesamt bestellungen': 'Total orders',
  'fehlende abs': 'Missing OCs',
  'bestellstatus uberblick': 'Order status overview',
  'erinnerungsstufen bei fehlenden ab': 'Reminder levels for missing OCs',
  'fehlende auftragsbestatigungen': 'Missing order confirmations',
  'live aus dem erp inkl. erinnerungsstand je bestellung.': 'Live from ERP including reminder status per order.',
  'offen': 'Open',
  'in bearbeitung': 'In progress',
  'gelost': 'Resolved',
  'keine eskalationen gefunden': 'No escalations found',
  'eskalationshistorie': 'Escalation history',
  'erinnerung': 'Reminder',
  'e-mail-inhalt': 'Email content',
  'nachte eskalation geplant ab': 'Next escalation scheduled from',
  'fur diese bestellung wurden keine eskalationsmails versendet.': 'No escalation emails were sent for this order.',
  'loschen': 'Delete',
  'abbrechen': 'Cancel',
  'erstellen': 'Create',
  'erstelle...': 'Creating...',
  'lade benutzer...': 'Loading users...',
  'kein zugriff. nur administratoren.': 'No access. Administrators only.',
  'neuer benutzer': 'New user',
  'neuen benutzer anlegen': 'Create new user',
  'anzeigename': 'Display name',
  'e-mail': 'Email',
  'letzter login': 'Last login',
  'aktionen': 'Actions',
  'aktiviert': 'Activated',
  'deaktiviert': 'Deactivated',
  'noch nie': 'Never',
  'passwort zurucksetzen': 'Reset password',
  'benutzer loschen': 'Delete user',
  'rollen & berechtigungen verwalten': 'Manage roles and permissions',
  'rollen-erklarung': 'Role overview',
  'kein vessel tracking fur diese bestellung': 'No vessel tracking for this order',
  'lieferzeitraum': 'Delivery period',
  'zurucksetzen': 'Reset',
  'unterwegs': 'In transit',
  'angekommen': 'Arrived',
  'nicht verschifft': 'Not shipped',
  'diese woche fallig': 'Due this week',
  'uberfallig': 'Overdue',
  'im zeitplan': 'On schedule',
  'im soll': 'On target',
  'kein eta verfugbar': 'No ETA available',
  'terminstaus': 'Schedule status',
  'auffalligkeiten': 'Irregularities',
  'sendung / ankunft': 'Shipment / arrival',
  'ab-prufung': 'OC check',
  'bestatiger termin': 'Confirmed date',
  'soll-termin': 'Planned date',
  'aktive sendungen': 'Active shipments',
  'punktlich': 'On time',
  'noch keine lieferungen vorhanden.': 'No deliveries available yet.',
  'keine lieferungen gefunden': 'No deliveries found',
  'bestellnr.': 'Order no.',
  'erstellt': 'Created',
  'beschreibung': 'Description',
  'prioritat': 'Priority',
  'quelle': 'Source',
  'typ': 'Type',
  'ampel-verteilung': 'Traffic-light distribution',
  'eskalationen nach typ': 'Escalations by type',
  'keine eskalationen vorhanden': 'No escalations available',
  'ampelstatus': 'Traffic-light status',
  'alle': 'All',
  'hinweis': 'Notice',
  'ok': 'OK',
  'stufe': 'Level',
  'noch keine': 'None yet',
  'letzte': 'Last',
  'nachste': 'Next',
  'material': 'Material',
  'bestellung': 'Order',
  'an': 'To',
  'zeitraum': 'Period',
  'absender, betreff oder bestellnr. suchen...': 'Search sender, subject or order no...',
  'abweichungen vor versand erkannt': 'Deviations detected before dispatch',
  'abweichungsgrunde': 'Deviation reasons',
  'adapter': 'Adapters',
  'aktivitaten konnten nicht geladen werden.': 'Activities could not be loaded.',
  'ankunft': 'Arrival',
  'benutzer erstellt': 'User created',
  'benutzer geloscht': 'User deleted',
  'bestatigt (ab)': 'Confirmed (OC)',
  'bestellubersicht konnte nicht geladen werden.': 'Order overview could not be loaded.',
  'eigenen status nicht anderbar': 'Cannot change your own status',
  'eingegangene ab': 'Received OCs',
  'eskalation': 'Escalation',
  'eskalation als gelost markiert': 'Escalation marked as resolved',
  'eskalationshistorie anzeigen': 'Show escalation history',
  'eskaliert': 'Escalated',
  'exportieren': 'Export',
  'fehler beim aktualisieren': 'Error while updating',
  'fehler beim erstellen': 'Error while creating',
  'fehler beim loschen': 'Error while deleting',
  'fruhwarn.': 'Early warn.',
  'fruhwarnquote': 'Early warning rate',
  'kennzahlen': 'Metrics',
  'klicken zum umschalten': 'Click to toggle',
  'letzte ab': 'Latest OC',
  'letzte lieferstatus-abfrage': 'Latest delivery-status request',
  'lieferantenliste konnte nicht geladen werden.': 'Supplier list could not be loaded.',
  'nachste eskalation geplant ab': 'Next escalation planned from',
  'neues passwort': 'New password',
  'noch keine abfrage gesendet': 'No request sent yet',
  'passwort zuruckgesetzt': 'Password reset',
  'reporting konnte nicht geladen werden.': 'Reporting could not be loaded.',
  'rolle': 'Role',
  'route': 'Route',
  'schiff': 'Vessel',
  'score-gewichtung': 'Score weighting',
  'soll-termin (erp)': 'Planned date (ERP)',
  'spatwarn.': 'Late warn.',
  'stand': 'Updated',
  'status aktualisiert': 'Status updated',
  'status geandert': 'Status changed',
  'tage': 'days',
  'terminstatus': 'Schedule status',
  'tracking-id': 'Tracking ID',
  'verarbeitet': 'processed',
  'vessel tracking': 'Vessel tracking',
  'voraussichtliche ankunft': 'Estimated arrival',
  'fehlend': 'Missing',
  'abweichend': 'Deviating',
  'korrekt': 'Correct',
  'eskalierungen aus ab': 'Escalations from OCs',
  'ab ausstehend': 'OC pending',
  'offene falle': 'Open cases',
  'stufe 1': 'Level 1',
  'stufe 2': 'Level 2',
  'stufe 3': 'Level 3',
  'weiterleitungen': 'Forwards',
  'transit-warnungen': 'Transit warnings',
  'aktionstyp': 'Action type',
  'weiterleitung': 'Forward',
  'transit-warnung': 'Transit warning',
  'unklarheit': 'Unclear item',
  'ab-verarbeitung': 'OC processing',
  'beschreibung, bestellnr., details...': 'Description, order no., details...',
  'ab-referenz': 'OC reference',
  'termin': 'Date',
  'abweichungen': 'Deviations',
  'id': 'ID',
  'pos.': 'Pos.',
  'noch keine auftragsbestatigungen verarbeitet.': 'No order confirmations processed yet.',
  'bestellnummer suchen...': 'Search order number...',
  'keine auftragsbestatigungen gefunden': 'No order confirmations found',
  'aktuell keine fehlenden auftragsbestatigungen im erp gefunden': 'No missing order confirmations currently found in ERP',
  'bestellungen, eskalationen (einsicht + bearbeitung), unklarheiten, lieferanten': 'Orders, escalations (view + edit), unclear items, suppliers',
  'messberichte, bestellungen (nur einsicht)': 'Inspection reports, orders (view only)',
  'lieferungen, vessel tracking, versanddokumente': 'Deliveries, vessel tracking, shipping documents',
  'voller zugriff + benutzerverwaltung + agent-steuerung': 'Full access + user management + agent control',
  'termintreue (50%)': 'On-time delivery (50%)',
  'dokumentenqualitat (30%)': 'Document quality (30%)',
  'reaktionszeit (20%)': 'Response time (20%)',
  'eskalationen offen / gesamt': 'Escalations open / total',
  'messberichte vollstandig / gesamt': 'Inspection reports complete / total',
  'ø reaktionszeit': 'Avg response time',
  'doku-qualitat': 'Doc quality',
  'abs': 'OCs',
  'eskl. offen': 'Esc. open',
  'ø performance score': 'Avg performance score',
  'score ≥ 80 (gut)': 'Score >= 80 (good)',
  'score < 60 (kritisch)': 'Score < 60 (critical)',
  'lieferant suchen...': 'Search supplier...',
  'eindeutige bestellnummer aus dem erp-system': 'Unique order number from the ERP system',
  'gewunschter liefertermin laut erp-bestellung': 'Requested delivery date according to ERP order',
  'bestatigter termin': 'Confirmed date',
  'vom lieferanten in der auftragsbestatigung (ab) zugesagter liefertermin': 'Delivery date committed by supplier in the order confirmation (OC)',
  'vergleicht berechnete verfugbarkeit (eta + nachlauf) mit dem bestatigten liefertermin. "im soll" = rechtzeitig, "+x tage" = voraussichtliche verspatung': 'Compares calculated availability (ETA + follow-up) with the confirmed delivery date. "On target" = on time, "+X days" = expected delay',
  'ergebnis des abgleichs: stimmen preis, menge und termin der auftragsbestatigung mit der bestellung uberein?': 'Matching result: do price, quantity and date in the order confirmation match the order?',
  'transportstatus: nicht verschifft, unterwegs oder angekommen - plus voraussichtliches ankunftsdatum': 'Transport status: not shipped, in transit, or arrived - plus estimated arrival date',
  'erkannte unterschiede zwischen bestellung und auftragsbestatigung (termin, menge oder preis)': 'Detected differences between order and order confirmation (date, quantity, or price)',
  'bestellnr. oder lieferant...': 'Order no. or supplier...',
  'zusammenfassung': 'Summary',
  'lieferanten-scores': 'Supplier scores',
  'performance-scores': 'Performance scores',
  'abs je lieferant': 'OCs per supplier',
  'alle eskalationen': 'All escalations',
  'alle messberichte': 'All inspection reports',
  'unvollstandige messberichte': 'Incomplete inspection reports',
  'alle aktivitaten': 'All activities',
  'gesamtbericht': 'Overall report',
  'alle bereiche in einer datei - fur management-reviews und monatsabschlusse.': 'All areas in one file - for management reviews and month-end reporting.',
  'lieferanten-bericht': 'Supplier report',
  'performance-scores aller lieferanten mit ab-aufschlusselung.': 'Performance scores of all suppliers with OC breakdown.',
  'eskalations-bericht': 'Escalation report',
  'offene und geschlossene eskalationen, abweichungsgrunde und fehlende auftragsbestatigungen.': 'Open and closed escalations, deviation reasons, and missing order confirmations.',
  'messberichte-bericht': 'Inspection report export',
  'alle eingegangenen messberichte mit vollstandigkeitsstatus.': 'All received inspection reports with completeness status.',
  'aktivitaten-bericht': 'Activity report',
  'vollstandiges agent-log aller aktionen sowie nicht zugeordnete e-mails.': 'Complete agent log of all actions plus unassigned emails.',
  'absender, betreff...': 'Sender, subject...',
  'ubersicht aller verarbeiteten bestellungen': 'Overview of all processed orders',
  'bestellungen': 'Orders',
  'abweichungen und offene aufgaben': 'Deviations and open tasks',
  'nicht zugeordnete e-mails': 'Unassigned emails',
  'agent-aktivitat': 'Agent activity',
  'automatische aktionen': 'Automated actions',
  'agent steuern und konfiguration': 'Control agent and configuration',
  'ki-gestutzte lieferterminverfolgung': 'AI-supported delivery tracking',
  'hoch': 'High',
  'mittel': 'Medium',
  'niedrig': 'Low',
  'terminabweichung': 'Schedule deviation',
  'preisabweichung': 'Price deviation',
  'mengenabweichung': 'Quantity deviation',
  'uberfallige lieferung': 'Overdue delivery',
  'fehlende dokumente': 'Missing documents',
  'messbericht unvollstandig': 'Inspection report incomplete',
  'ab-verarbeitungen': 'OC processings',
};

export function translateText(text: string, language: Language): string {
  if (language !== 'en') {
    return text;
  }

  const key = normalizeKey(text);
  return EN_TRANSLATIONS[key] ?? text;
}
